import React, {FC} from 'react';

import * as PanelSettingsViewTypes from '../../state/views/panelSettings/types';
import {ImageExportType} from '../../util/panelExport';
import {PanelCompRedux} from '../../util/panels';
import {getPanelSpec, PanelExportRef} from '../../util/panelTypes';
import {usePanelContext} from '../Panel/PanelContextProvider';
import {usePanelsSharedRefsContext} from '../Views/contexts/PanelsSharedRefsContext';
import ImageExportModal from './ImageExportModal';
import * as S from './PanelImageExportModal.styles';

type PanelImageExportModalProps = {
  open?: boolean;
  type: ImageExportType;
  onClose: () => void;
  panelSpec: ReturnType<typeof getPanelSpec>;
  panelSettings?: PanelSettingsViewTypes.PanelSettings;
};

export const PanelImageExportModal: FC<PanelImageExportModalProps> = React.memo(
  ({open, type, onClose, panelSettings, panelSpec}) => {
    const panelDOMRef = React.useRef<HTMLDivElement>(null);
    const panelExportRef = React.useRef<PanelExportRef>();

    const {customRunColorsRef} = usePanelsSharedRefsContext();
    const {isReadOnly, panelRef} = usePanelContext();

    return (
      <ImageExportModal
        open={open}
        type={type}
        panelDOMRef={panelDOMRef}
        panelExportRef={panelExportRef}
        viewType={panelSpec.type}
        onClose={onClose}>
        <S.PanelContainer
          className={
            panelSpec.type.toLowerCase().replace(' ', '-') +
            '-container' +
            ' fullscreen-mode'
          }
          ref={panelDOMRef}>
          <PanelCompRedux
            exportMode
            configMode={false}
            currentHeight={320}
            panelRef={panelRef}
            dimensions={undefined as any}
            readOnly={isReadOnly}
            panelExportRef={panelExportRef}
          />
        </S.PanelContainer>
      </ImageExportModal>
    );
  }
);
